import { observer } from "mobx-react";
import * as React from "react";
import { withStores } from "src/stores";
import { UitkButtonToggleGroup } from "uitk-react-button-toggle";
import { UitkLayoutFlex, UitkLayoutFlexItem } from "uitk-react-layout-flex";
import { ButtonToggle } from "../components/ButtonToggle";
import { PropertyFiltersComponentGroupProps } from "../typings";

export const ButtonToggleGroup = withStores("propertyFilters")(
  observer((props: PropertyFiltersComponentGroupProps) => {
    const { filterName, options, moduleName } = props;

    return (
      <UitkLayoutFlex wrap="wrap">
        <UitkLayoutFlexItem>
          <UitkButtonToggleGroup wrapButtons>
            {options.map((option, index) => (
              <ButtonToggle
                key={`${option.optionValue}-${index}`}
                option={option}
                filterName={filterName}
                moduleName={moduleName}
              />
            ))}
          </UitkButtonToggleGroup>
        </UitkLayoutFlexItem>
      </UitkLayoutFlex>
    );
  })
);

export default ButtonToggleGroup;
